import { Constant } from '@genial/config';
import { Utils } from '@genial/utils';
import { useRecoilState } from 'recoil';

import { TokenStateTypes, tokenState } from './state';

export const useToken = () => {
  const [token, setTokenState] = useRecoilState<TokenStateTypes.TokenStatus>(tokenState);

  const getToken = async () => {
    try {
      const tokenValue = Utils.Cookie.GetItem(Constant.CookieTokenKey);

      setTokenState({
        value: tokenValue,
        isExpired: Utils.Jwt.Expired(tokenValue),
        isValid: Utils.Jwt.Validate(tokenValue),
      });
    } catch (error) {
      console.error('Error getting token:', error);
      setTokenState({
        value: null,
        isExpired: false,
        isValid: false,
      });
    }
  };

  const setToken = async (newToken: string) => {
    try {
      await Utils.Cookie.SetItem(Constant.CookieTokenKey, newToken);

      setTokenState({
        value: newToken,
        isExpired: Utils.Jwt.Expired(newToken),
        isValid: Utils.Jwt.Validate(newToken),
      });
    } catch (error) {
      console.error('Error setting token:', error);
    }
  };

  return { token, getToken, setToken };
};
